import { AuctionNearMeHit } from '@/pages/AuctionsNearMe/types/AuctionsNearMe.types';
import {
    AuctionsNearMeReducerAction,
    ClearSsrAuctionsNearMeHitsAction,
    PopulateSsrAuctionsNearMeAction,
} from '@/redux/modules/auctionsNearMe/auctionsNearMe.types';
import {
    CLEAR_SSR_AUCTIONS_NEAR_ME_HITS,
    POPULATE_SSR_AUCTIONS_NEAR_ME_HITS,
} from '@/redux/modules/actions/auctionsNearMe/auctionsNearMe';

export type AuctionsNearMeState = {
    hits: AuctionNearMeHit[];
};

export const defaultAuctionsNearMeState: AuctionsNearMeState = {
    hits: [],
};

const reducer = (state = defaultAuctionsNearMeState, action: AuctionsNearMeReducerAction): AuctionsNearMeState => {
    switch (action.type) {
        case POPULATE_SSR_AUCTIONS_NEAR_ME_HITS:
            return {
                ...state,
                hits: action.payload,
            };
        case CLEAR_SSR_AUCTIONS_NEAR_ME_HITS:
            return {
                ...state,
                hits: [],
            };
        default:
            return state;
    }
};

export default reducer;

export const populateSsrAuctionsNearMeHits =
    (hits: AuctionNearMeHit[]) =>
    async (dispatch: Function): Promise<void> => {
        const populateAction: PopulateSsrAuctionsNearMeAction = {
            error: null,
            meta: null,
            payload: hits,
            type: POPULATE_SSR_AUCTIONS_NEAR_ME_HITS,
        };
        await dispatch(populateAction);
    };

export const clearSsrAuctionsNearMeHits =
    () =>
    async (dispatch: Function): Promise<void> => {
        const clearAction: ClearSsrAuctionsNearMeHitsAction = {
            error: null,
            meta: null,
            payload: null,
            type: CLEAR_SSR_AUCTIONS_NEAR_ME_HITS,
        };
        await dispatch(clearAction);
    };
